'use strict';
import React from 'react';
import flux from 'utils/flux';
import AltContainer from 'alt-container';
import HeaderSearch from 'components/headerBar/headerSearch';
import dom from 'utils/dom';
import {Link} from 'react-router';

var HelpPage = React.createClass({
    displayName: 'HelpPage',
    mixins: [],
    statics: {
        willTransitionTo: function(transition) {
            if (!flux.getStore('app').isAuthenticated()) {
                transition.redirect('/login', {}, {nextPath: transition.path});
            }
            if (!flux.getStore('app').hasAcceptedLatestTerms()) {
                transition.redirect('/accept_terms', {}, {nextPath: transition.path});
            }
        }
    },
    render() {
        return (
            <AltContainer stores={{mediaStore: flux.getStore('media')}}
                render={(props) => {
                    return (
                        <div className="page help">

                            <div className="headerbar">
                                <div className="container--centered">
                                    <HeaderSearch query={props.mediaStore.params.search }/>
                                </div>
                            </div>

                            <div className="help__container container--centered">
                                <div className="container__navigation">
                                    <Link to="listing" className="sidebar__back">
                                        <i className="gopro-chevron-left"/>
                                        {flux.t('back_to_home')}
                                    </Link>
                                </div>
                                <div className="container__content">
                                    <div dangerouslySetInnerHTML={dom.setInnerHtml(flux.t('help_me_text'))} />
                                </div>

                            </div>
                        </div>
                    );
                }}>
            </AltContainer>
        );
    }
});

module.exports = HelpPage;



// WEBPACK FOOTER //
// ./app/pages/help/index.jsx